"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AuthButtons = function (_a) {
    var _b = _a.textVariant, textVariant = _b === void 0 ? 'upper' : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var openSignIn = (0, apps_shared_1.useOpenSignIn)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.authButtonWrapper },
        react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: textVariant, onClick: openSignIn }, t('login')),
        react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: textVariant, onClick: openSignUp }, t('signup'))));
};
exports.default = react_1.default.memo(AuthButtons);
